<script setup lang="ts">
/**
 * NotificationContainer - контейнер для toast-уведомлений.
 * Отрисовывает уведомления из notification store.
 */
import { useNotificationStore } from '@/stores/notification'

const store = useNotificationStore()

const typeClasses: Record<string, string> = {
  success: 'alert-success',
  error: 'alert-error',
  warning: 'alert-warning',
  info: 'alert-info',
}
</script>

<template>
  <div class="toast toast-end toast-top z-50 mt-16">
    <TransitionGroup
      name="notification"
      tag="div"
      class="flex flex-col gap-2"
    >
      <div
        v-for="notification in store.notifications"
        :key="notification.id"
        class="alert shadow-lg max-w-sm animate-slide-left"
        :class="typeClasses[notification.type]"
      >
        <div class="flex-1">
          <span class="font-semibold text-sm">{{ notification.title }}</span>
          <p
            v-if="notification.message"
            class="text-xs opacity-80 mt-0.5"
          >
            {{ notification.message }}
          </p>
        </div>
        <button
          v-if="notification.dismissible"
          class="btn btn-ghost btn-xs btn-square"
          @click="store.dismiss(notification.id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.notification-enter-active {
  transition: all 0.3s ease-out;
}
.notification-leave-active {
  transition: all 0.2s ease-in;
}
.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
